var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "../themes/styled";
import Text from "../text/Text";
import { prop } from "styled-tools";
var GradientTextContainer = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: linear-gradient(90deg, ", ", 25%, ", ");\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n"], ["\n    background: linear-gradient(90deg, ", ", 25%, ", ");\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n"])), prop("startColor", "#000"), prop("endColor", "#000"));
var GradientText = function (_a) {
    var startColor = _a.startColor, endColor = _a.endColor, children = _a.children, rest = __rest(_a, ["startColor", "endColor", "children"]);
    return (React.createElement(GradientTextContainer, { startColor: startColor, endColor: endColor },
        React.createElement(Text, __assign({ as: "span" }, rest), children)));
};
export default GradientText;
var templateObject_1;
//# sourceMappingURL=GradientText.js.map